
import { createRoot } from 'react-dom/client'
import React from 'react'
import './index.css'
import App from './App'

// Create a simple loading component with minimal styling
const Loading = () => (
  <div className="h-screen w-screen flex items-center justify-center bg-white">
    <div className="text-center">
      <div className="w-16 h-16 border-4 border-piano-gold border-t-transparent rounded-full animate-spin mx-auto"></div>
      <p className="mt-4 text-gray-600">Indlæser...</p>
    </div>
  </div>
)

// Add debug logging
console.log('Application starting...');

// Register performance metrics
if ('performance' in window && 'PerformanceObserver' in window) {
  // Monitor Core Web Vitals
  const vitalsObserver = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      // Report to console in development
      if (process.env.NODE_ENV === 'development') {
        console.log(`[Performance] ${entry.name}:`, entry);
      }
    });
  });
  
  // Observe FCP, LCP, CLS metrics
  vitalsObserver.observe({ type: 'largest-contentful-paint', buffered: true });
  vitalsObserver.observe({ type: 'first-contentful-paint', buffered: true });
  vitalsObserver.observe({ type: 'layout-shift', buffered: true });
  
  // Report navigation timing data
  const pageNavigation = performance.getEntriesByType('navigation')[0];
  if (pageNavigation) {
    // Only log in development
    if (process.env.NODE_ENV === 'development') {
      console.log('[Navigation] DOM Complete:', (pageNavigation as PerformanceNavigationTiming).domComplete);
    }
  }
}

// Create root and render App
const rootElement = document.getElementById("root");

if (rootElement) {
  // Create the root once
  const root = createRoot(rootElement);
  
  console.log('Rendering application...');
  
  // Render the app
  root.render(
    <React.StrictMode>
      <React.Suspense fallback={<Loading />}>
        <App />
      </React.Suspense>
    </React.StrictMode>
  )
  
  console.log('Application rendered.');
}

// Load non-critical resources after main content
window.addEventListener('load', () => {
  console.log('Window load event fired.');
  // Use requestIdleCallback for non-critical operations
  if ('requestIdleCallback' in window) {
    // @ts-ignore - TypeScript might not have requestIdleCallback types
    window.requestIdleCallback(() => {
      // Preload assets that might be needed later
      const prefetchResources = [
        '/undervisning',
        '/om',
        '/kontakt'
      ];
      
      prefetchResources.forEach(path => {
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = path;
        document.head.appendChild(link);
      });
    });
  } else {
    // Fallback for browsers without requestIdleCallback
    setTimeout(() => {
      // Add passive event listeners for better scroll performance
      document.addEventListener('scroll', () => {}, { passive: true });
      document.addEventListener('touchstart', () => {}, { passive: true });
    }, 2000);
  }
});
